import { useState, useEffect } from "react";
import { fetchProducts, ShopifyProduct } from "@/lib/shopify";

/**
 * Lightweight hook that checks whether any products are currently on sale.
 * Caches the result in memory so the check runs at most once per session.
 */
let cachedHasSale: boolean | null = null;

export function useSaleDetection() {
  const [hasSale, setHasSale] = useState(cachedHasSale ?? false);
  const [checked, setChecked] = useState(cachedHasSale !== null);

  useEffect(() => {
    if (cachedHasSale !== null) return;

    fetchProducts(50)
      .then((products) => {
        const found = products.some((p: ShopifyProduct) => {
          const compareAt = p.node.compareAtPriceRange?.minVariantPrice;
          const price = p.node.priceRange.minVariantPrice;
          const hasCompareDiscount =
            compareAt &&
            parseFloat(compareAt.amount) > parseFloat(price.amount);
          const hasSaleTag = p.node.tags?.some(
            (t: string) => t.toLowerCase() === "sale"
          );
          return hasCompareDiscount || hasSaleTag;
        });
        cachedHasSale = found;
        setHasSale(found);
        setChecked(true);
      })
      .catch(() => {
        cachedHasSale = false;
        setHasSale(false);
        setChecked(true);
      });
  }, []);

  return { hasSale, checked };
}
